module.exports = __webpack_public_path__ + "static/media/dash.951d489f.svg";